export const mockData = [
  {
      "date": "2020-03-17",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1250,
                  "lb": 2750
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 58,
                  "lb": 128
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-18",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1250,
                  "lb": 2750
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 58,
                  "lb": 128
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-19",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-20",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 750,
                  "lb": 1650
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 35,
                  "lb": 77
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 375,
                  "lb": 825
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 17,
                  "lb": 38
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-21",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 375,
                  "lb": 825
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 17,
                  "lb": 38
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-22",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1250,
                  "lb": 2750
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 58,
                  "lb": 128
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-23",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-25",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2040,
                  "lb": 4488
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 270,
                  "lb": 594
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 18,
                  "lb": 40
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 90,
                          "lb": 198
                      },
                      "oneRepMax": {
                          "kg": 18,
                          "lb": 40
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 90,
                          "lb": 198
                      },
                      "oneRepMax": {
                          "kg": 18,
                          "lb": 40
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 90,
                          "lb": 198
                      },
                      "oneRepMax": {
                          "kg": 18,
                          "lb": 40
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-26",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1560,
                  "lb": 3432
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-27",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-28",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 25,
                  "lb": 55,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 35,
                  "lb": 77
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-29",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1320,
                  "lb": 2904
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-30",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 25,
                  "lb": 55,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 35,
                  "lb": 77
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 35,
                          "lb": 77
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-03-31",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1312.5,
                  "lb": 2900
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 61,
                  "lb": 135
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-01",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1312.5,
                  "lb": 2900
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 61,
                  "lb": 135
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-02",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-03",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 812.5,
                  "lb": 1800
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 84
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 162.5,
                          "lb": 360
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 162.5,
                          "lb": 360
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 162.5,
                          "lb": 360
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 162.5,
                          "lb": 360
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 162.5,
                          "lb": 360
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 375,
                  "lb": 825
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 17,
                  "lb": 38
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-04",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1062.5,
                  "lb": 2350
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 50,
                  "lb": 110
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 375,
                  "lb": 825
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 17,
                  "lb": 38
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 75,
                          "lb": 165
                      },
                      "oneRepMax": {
                          "kg": 17,
                          "lb": 38
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1062.5,
                  "lb": 2350
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 50,
                  "lb": 110
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 212.5,
                          "lb": 470
                      },
                      "oneRepMax": {
                          "kg": 50,
                          "lb": 110
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-05",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2750,
                  "lb": 6050
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-06",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 330,
                  "lb": 726
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 90,
                          "lb": 198
                      },
                      "oneRepMax": {
                          "kg": 18,
                          "lb": 40
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-07",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-08",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-09",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1980,
                  "lb": 4392
              },
              "maxWeight": {
                  "kg": 27.5,
                  "lb": 61,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 85
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 340,
                  "lb": 748
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-10",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-11",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 990,
                  "lb": 2196
              },
              "maxWeight": {
                  "kg": 27.5,
                  "lb": 61,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 85
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 27.5,
                          "lb": 61
                      },
                      "setVolume": {
                          "kg": 330,
                          "lb": 732
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 85
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-13",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-14",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-15",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-16",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 875,
                  "lb": 1925
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 41,
                  "lb": 90
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 385
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 90
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 385
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 90
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 385
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 90
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 385
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 90
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 385
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 90
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 600,
                  "lb": 1320
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-17",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1125,
                  "lb": 2475
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 115
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 600,
                  "lb": 1320
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1125,
                  "lb": 2475
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 115
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 495
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 115
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-18",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3000,
                  "lb": 6600
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 176
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 176
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-20",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-21",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-22",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-23",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-24",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-25",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-27",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-28",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-29",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-04-30",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 937.5,
                  "lb": 2075
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 44,
                  "lb": 97
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 750,
                  "lb": 1650
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-01",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1187.5,
                  "lb": 2625
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 55,
                  "lb": 122
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 600,
                  "lb": 1320
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1187.5,
                  "lb": 2625
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 55,
                  "lb": 122
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 237.5,
                          "lb": 525
                      },
                      "oneRepMax": {
                          "kg": 55,
                          "lb": 122
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-02",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3900,
                  "lb": 8580
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-04",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-05",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2070,
                  "lb": 4572
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 178
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-06",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1350,
                  "lb": 2988
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 116
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-07",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2275,
                  "lb": 5040
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 720
                      },
                      "oneRepMax": {
                          "kg": 43,
                          "lb": 96
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-08",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1350,
                  "lb": 2988
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 116
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1350,
                  "lb": 2988
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 116
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-09",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-11",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-12",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-13",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-14",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-15",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1250,
                  "lb": 2750
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 58,
                  "lb": 128
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 750,
                  "lb": 1650
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1250,
                  "lb": 2750
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 58,
                  "lb": 128
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 550
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 128
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-16",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 4200,
                  "lb": 9240
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-18",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4768
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1192
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 189
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1615,
                  "lb": 3570
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1050
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 140
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-19",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-20",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-21",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2340,
                  "lb": 5184
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-22",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-23",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-25",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-26",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-27",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-28",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-29",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1312.5,
                  "lb": 2900
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 61,
                  "lb": 135
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 750,
                  "lb": 1650
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1312.5,
                  "lb": 2900
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 61,
                  "lb": 135
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 262.5,
                          "lb": 580
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-05-30",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 4650,
                  "lb": 10260
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-01",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-02",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2070,
                  "lb": 4572
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 178
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-03",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-04",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2340,
                  "lb": 5184
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-05",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-06",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2070,
                  "lb": 4572
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 178
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2790,
                  "lb": 6156
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 360,
                          "lb": 792
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-08",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-09",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-10",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-11",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-12",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 750,
                  "lb": 1650
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-13",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 4800,
                  "lb": 10560
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-15",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1600,
                  "lb": 3520
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-16",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-17",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-18",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2340,
                  "lb": 5184
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-19",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-20",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2070,
                  "lb": 4572
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 178
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2880,
                  "lb": 6336
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 720,
                  "lb": 1584
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 84
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-22",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-23",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-24",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-25",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-26",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-27",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 4950,
                  "lb": 10920
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-29",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1700,
                  "lb": 3740
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-06-30",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-01",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-02",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2340,
                  "lb": 5184
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-03",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-04",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2970,
                  "lb": 6552
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 780,
                  "lb": 1728
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 41,
                  "lb": 91
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-06",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-07",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-08",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-10",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-11",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1375,
                  "lb": 3025
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 64,
                  "lb": 141
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 275,
                          "lb": 605
                      },
                      "oneRepMax": {
                          "kg": 64,
                          "lb": 141
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-12",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 4950,
                  "lb": 10920
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-13",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-14",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-15",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-16",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-17",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-18",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2070,
                  "lb": 4572
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 80,
                  "lb": 178
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 690,
                          "lb": 1524
                      },
                      "oneRepMax": {
                          "kg": 80,
                          "lb": 178
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2970,
                  "lb": 6552
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 780,
                  "lb": 1728
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 41,
                  "lb": 91
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-27",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-28",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-29",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-30",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-07-31",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-01",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5100,
                  "lb": 11220
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 119,
                  "lb": 262
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-03",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-04",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-05",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-06",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-07",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3384
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 59,
                  "lb": 132
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 510,
                          "lb": 1128
                      },
                      "oneRepMax": {
                          "kg": 59,
                          "lb": 132
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-08",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1170,
                  "lb": 2592
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 101
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 390,
                          "lb": 864
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 101
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3060,
                  "lb": 6732
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 119,
                  "lb": 262
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 780,
                  "lb": 1728
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 41,
                  "lb": 91
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-10",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-11",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-12",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-13",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-14",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-15",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5100,
                  "lb": 11220
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 119,
                  "lb": 262
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-17",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-18",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-19",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-20",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-21",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1485,
                  "lb": 3267
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 405,
                          "lb": 891
                      },
                      "oneRepMax": {
                          "kg": 58,
                          "lb": 129
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1530,
                  "lb": 3366
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 132
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-22",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3060,
                  "lb": 6732
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 119,
                  "lb": 262
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 780,
                  "lb": 1728
              },
              "maxWeight": {
                  "kg": 32.5,
                  "lb": 72,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 41,
                  "lb": 91
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 32.5,
                          "lb": 72
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 576
                      },
                      "oneRepMax": {
                          "kg": 41,
                          "lb": 91
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-24",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-25",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-26",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-27",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-28",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3175
              },
              "maxWeight": {
                  "kg": 57.5,
                  "lb": 127,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 148
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 57.5,
                          "lb": 127
                      },
                      "setVolume": {
                          "kg": 287.5,
                          "lb": 635
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 148
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-29",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5100,
                  "lb": 11220
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 119,
                  "lb": 262
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 1020,
                          "lb": 2244
                      },
                      "oneRepMax": {
                          "kg": 119,
                          "lb": 262
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-08-31",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-01",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-02",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2790,
                  "lb": 6156
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-03",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-04",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1530,
                  "lb": 3366
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 132
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-05",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3150,
                  "lb": 6948
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 270
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-07",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-08",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-09",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2437.5,
                  "lb": 5375
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 114,
                  "lb": 251
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-10",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-11",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-12",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2125,
                  "lb": 4675
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 99,
                  "lb": 218
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 425,
                          "lb": 935
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 218
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5250,
                  "lb": 11580
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 270
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-14",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2465,
                  "lb": 5440
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-15",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2080,
                  "lb": 4576
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-16",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2790,
                  "lb": 6156
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-17",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-18",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1575,
                  "lb": 3465
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 495,
                          "lb": 1089
                      },
                      "oneRepMax": {
                          "kg": 61,
                          "lb": 135
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-19",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3150,
                  "lb": 6948
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 270
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-21",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-22",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-23",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2437.5,
                  "lb": 5375
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 114,
                  "lb": 251
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-24",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-25",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-26",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5250,
                  "lb": 11580
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 270
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 1050,
                          "lb": 2316
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 270
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-28",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2537.5,
                  "lb": 5600
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 797.5,
                          "lb": 1760
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 219
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-29",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-09-30",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2790,
                  "lb": 6156
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-01",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-02",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-03",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3240,
                  "lb": 7128
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-05",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-06",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-07",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2437.5,
                  "lb": 5375
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 114,
                  "lb": 251
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-08",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-09",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-10",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5400,
                  "lb": 11880
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-12",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-13",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-14",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2880,
                  "lb": 6336
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-15",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-16",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-17",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3240,
                  "lb": 7128
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-19",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1687.5,
                  "lb": 3725
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 79,
                  "lb": 174
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 337.5,
                          "lb": 745
                      },
                      "oneRepMax": {
                          "kg": 79,
                          "lb": 174
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-20",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-21",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2437.5,
                  "lb": 5375
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 114,
                  "lb": 251
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 487.5,
                          "lb": 1075
                      },
                      "oneRepMax": {
                          "kg": 114,
                          "lb": 251
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-22",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-23",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 300,
                          "lb": 660
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-10-24",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5400,
                  "lb": 11880
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-02",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1890,
                  "lb": 4176
              },
              "maxWeight": {
                  "kg": 52.5,
                  "lb": 116,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 52.5,
                          "lb": 116
                      },
                      "setVolume": {
                          "kg": 630,
                          "lb": 1392
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 162
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-03",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2170,
                  "lb": 4774
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 490,
                          "lb": 1078
                      },
                      "oneRepMax": {
                          "kg": 86,
                          "lb": 190
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-04",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2880,
                  "lb": 6336
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-05",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-06",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-07",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2160,
                  "lb": 4752
              },
              "maxWeight": {
                  "kg": 60,
                  "lb": 132,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 84,
                  "lb": 185
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 60,
                          "lb": 132
                      },
                      "setVolume": {
                          "kg": 720,
                          "lb": 1584
                      },
                      "oneRepMax": {
                          "kg": 84,
                          "lb": 185
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3240,
                  "lb": 7128
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-09",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-10",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-11",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-12",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-13",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1437.5,
                  "lb": 3174
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1062.5,
                  "lb": 2346
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-14",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2187.5,
                  "lb": 4825
              },
              "maxWeight": {
                  "kg": 87.5,
                  "lb": 193,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 87.5,
                          "lb": 193
                      },
                      "setVolume": {
                          "kg": 437.5,
                          "lb": 965
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5400,
                  "lb": 11880
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-16",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1760,
                  "lb": 3872
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-17",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2380,
                  "lb": 5236
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2340,
                  "lb": 5148
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 91,
                  "lb": 200
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 780,
                          "lb": 1716
                      },
                      "oneRepMax": {
                          "kg": 91,
                          "lb": 200
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-18",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2880,
                  "lb": 6336
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-19",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-20",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1620,
                  "lb": 3564
              },
              "maxWeight": {
                  "kg": 45,
                  "lb": 99,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 45,
                          "lb": 99
                      },
                      "setVolume": {
                          "kg": 540,
                          "lb": 1188
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-21",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1260,
                  "lb": 2772
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3240,
                  "lb": 7128
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 126,
                  "lb": 277
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 1080,
                          "lb": 2376
                      },
                      "oneRepMax": {
                          "kg": 126,
                          "lb": 277
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-23",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-24",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-25",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-26",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-27",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1500,
                  "lb": 3312
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1062.5,
                  "lb": 2346
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-28",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5550,
                  "lb": 12240
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-11-30",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1870,
                  "lb": 4114
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 605,
                          "lb": 1331
                      },
                      "oneRepMax": {
                          "kg": 75,
                          "lb": 165
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 605,
                          "lb": 1331
                      },
                      "oneRepMax": {
                          "kg": 75,
                          "lb": 165
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-01",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1080,
                  "lb": 2376
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-02",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2880,
                  "lb": 6336
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 112,
                  "lb": 246
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 960,
                          "lb": 2112
                      },
                      "oneRepMax": {
                          "kg": 112,
                          "lb": 246
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-03",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-04",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1520,
                  "lb": 3360
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1050
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 140
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1050
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 140
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1140,
                  "lb": 2520
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 60,
                  "lb": 133
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-05",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3330,
                  "lb": 7344
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 630,
                  "lb": 1386
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 92
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 462
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 92
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-07",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-08",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-09",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-10",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-11",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 937.5,
                  "lb": 2070
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 3
              },
              "max1RM": {
                  "kg": 69,
                  "lb": 152
              },
              "sets": [
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-12",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5550,
                  "lb": 12240
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-14",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 100,
                  "lb": 220
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-15",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-16",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2970,
                  "lb": 6552
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-17",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-18",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1615,
                  "lb": 3570
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 522.5,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 522.5,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1140,
                  "lb": 2520
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 60,
                  "lb": 133
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2020-12-19",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1350,
                  "lb": 2988
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 52,
                  "lb": 116
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 996
                      },
                      "oneRepMax": {
                          "kg": 52,
                          "lb": 116
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3330,
                  "lb": 7344
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 450,
                  "lb": 996
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 94
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-04",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1750,
                  "lb": 3850
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 82,
                  "lb": 180
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 350,
                          "lb": 770
                      },
                      "oneRepMax": {
                          "kg": 82,
                          "lb": 180
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-05",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-06",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-07",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-08",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1000,
                  "lb": 2208
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 71,
                  "lb": 156
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-09",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5550,
                  "lb": 12240
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-11",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 100,
                  "lb": 220
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-12",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-13",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2970,
                  "lb": 6552
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-14",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-15",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1662.5,
                  "lb": 3675
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 522.5,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1140,
                  "lb": 2520
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 60,
                  "lb": 133
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-16",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3330,
                  "lb": 7344
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 129,
                  "lb": 286
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 1110,
                          "lb": 2448
                      },
                      "oneRepMax": {
                          "kg": 129,
                          "lb": 286
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 450,
                  "lb": 996
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 94
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-18",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-19",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-20",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-21",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-22",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1062.5,
                  "lb": 2346
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 71,
                  "lb": 156
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  },
                  {
                      "reps": 3,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 414
                      },
                      "oneRepMax": {
                          "kg": 69,
                          "lb": 152
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-01-23",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5700,
                  "lb": 12540
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-09",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 100,
                  "lb": 220
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1870,
                  "lb": 4114
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 550,
                          "lb": 1210
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-10",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 98,
                  "lb": 216
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 840,
                          "lb": 1848
                      },
                      "oneRepMax": {
                          "kg": 98,
                          "lb": 216
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2025,
                  "lb": 4470
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 675,
                          "lb": 1490
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 675,
                          "lb": 1490
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 675,
                          "lb": 1490
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-12",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2970,
                  "lb": 6552
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 115,
                  "lb": 255
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 990,
                          "lb": 2184
                      },
                      "oneRepMax": {
                          "kg": 115,
                          "lb": 255
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 7
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 139
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 139
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 420,
                  "lb": 936
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 22,
                  "lb": 49
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 140,
                          "lb": 312
                      },
                      "oneRepMax": {
                          "kg": 22,
                          "lb": 49
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 140,
                          "lb": 312
                      },
                      "oneRepMax": {
                          "kg": 22,
                          "lb": 49
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 140,
                          "lb": 312
                      },
                      "oneRepMax": {
                          "kg": 22,
                          "lb": 49
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-15",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-16",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1662.5,
                  "lb": 3675
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 522.5,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1140,
                  "lb": 2520
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 60,
                  "lb": 133
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 380,
                          "lb": 840
                      },
                      "oneRepMax": {
                          "kg": 60,
                          "lb": 133
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-17",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4968
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 193
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1656
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 193
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3420,
                  "lb": 7524
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 450,
                  "lb": 996
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 42,
                  "lb": 94
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 332
                      },
                      "oneRepMax": {
                          "kg": 42,
                          "lb": 94
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-19",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-22",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 1937.5,
                  "lb": 4275
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 90,
                  "lb": 199
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 387.5,
                          "lb": 855
                      },
                      "oneRepMax": {
                          "kg": 90,
                          "lb": 199
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-23",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2500,
                  "lb": 5500
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 117,
                  "lb": 257
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 117,
                          "lb": 257
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-24",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-25",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1250,
                  "lb": 2760
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 71,
                  "lb": 156
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 250,
                          "lb": 552
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 156
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-02-27",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 90,
                  "lb": 198,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 90,
                          "lb": 198
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5700,
                  "lb": 12540
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-01",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2250,
                  "lb": 4950
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 100,
                  "lb": 220
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 750,
                          "lb": 1650
                      },
                      "oneRepMax": {
                          "kg": 100,
                          "lb": 220
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1925,
                  "lb": 4235
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 605,
                          "lb": 1331
                      },
                      "oneRepMax": {
                          "kg": 75,
                          "lb": 165
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-02",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2030,
                  "lb": 4480
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 97,
                  "lb": 213
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 580,
                          "lb": 1280
                      },
                      "oneRepMax": {
                          "kg": 92,
                          "lb": 203
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2430,
                  "lb": 5364
              },
              "maxWeight": {
                  "kg": 67.5,
                  "lb": 149,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 94,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 67.5,
                          "lb": 149
                      },
                      "setVolume": {
                          "kg": 810,
                          "lb": 1788
                      },
                      "oneRepMax": {
                          "kg": 94,
                          "lb": 209
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-03",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2040,
                  "lb": 4488
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 237
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1350,
                  "lb": 2970
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 65,
                  "lb": 143
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 450,
                          "lb": 990
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 525,
                  "lb": 1170
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 23,
                  "lb": 52
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-04",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-05",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1282.5,
                  "lb": 2835
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 62,
                  "lb": 136
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-06",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3420,
                  "lb": 7524
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 562.5,
                  "lb": 1245
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 44,
                  "lb": 97
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-08",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1812.5,
                  "lb": 4000
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 85,
                  "lb": 187
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 362.5,
                          "lb": 800
                      },
                      "oneRepMax": {
                          "kg": 85,
                          "lb": 187
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-09",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-10",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2625,
                  "lb": 5775
              },
              "maxWeight": {
                  "kg": 105,
                  "lb": 231,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 269
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-11",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-12",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-13",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5700,
                  "lb": 12540
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-15",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2475,
                  "lb": 5445
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 11
              },
              "max1RM": {
                  "kg": 102,
                  "lb": 225
              },
              "sets": [
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 825,
                          "lb": 1815
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 825,
                          "lb": 1815
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 825,
                          "lb": 1815
                      },
                      "oneRepMax": {
                          "kg": 102,
                          "lb": 225
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-16",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2175,
                  "lb": 4800
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 97,
                  "lb": 213
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-17",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2040,
                  "lb": 4488
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 237
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 680,
                          "lb": 1496
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 237
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1500,
                  "lb": 3300
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 67,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 500,
                          "lb": 1100
                      },
                      "oneRepMax": {
                          "kg": 67,
                          "lb": 147
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 525,
                  "lb": 1170
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 23,
                  "lb": 52
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 175,
                          "lb": 390
                      },
                      "oneRepMax": {
                          "kg": 23,
                          "lb": 52
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-18",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-19",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1282.5,
                  "lb": 2835
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 62,
                  "lb": 136
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-20",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1950,
                  "lb": 4290
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 191
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3420,
                  "lb": 7524
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 562.5,
                  "lb": 1245
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 44,
                  "lb": 97
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-22",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-23",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-29",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2625,
                  "lb": 5775
              },
              "maxWeight": {
                  "kg": 105,
                  "lb": 231,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 269
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-30",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-03-31",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1300,
                  "lb": 2860
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 74,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-01",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5700,
                  "lb": 12540
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 133,
                  "lb": 293
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 1140,
                          "lb": 2508
                      },
                      "oneRepMax": {
                          "kg": 133,
                          "lb": 293
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-05",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-06",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2465,
                  "lb": 5440
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 725,
                          "lb": 1600
                      },
                      "oneRepMax": {
                          "kg": 97,
                          "lb": 213
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2100,
                  "lb": 4620
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-07",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2295,
                  "lb": 5049
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 110,
                  "lb": 243
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 765,
                          "lb": 1683
                      },
                      "oneRepMax": {
                          "kg": 110,
                          "lb": 243
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 765,
                          "lb": 1683
                      },
                      "oneRepMax": {
                          "kg": 110,
                          "lb": 243
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 765,
                          "lb": 1683
                      },
                      "oneRepMax": {
                          "kg": 110,
                          "lb": 243
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 630,
                  "lb": 1404
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 24,
                  "lb": 55
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-08",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-09",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1662.5,
                  "lb": 3675
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 522.5,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 65,
                          "lb": 143
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1282.5,
                  "lb": 2835
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 62,
                  "lb": 136
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-10",
      "workout": "Legs - Light",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 56,
                  "lb": 123
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 480,
                          "lb": 1056
                      },
                      "oneRepMax": {
                          "kg": 56,
                          "lb": 123
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3510,
                  "lb": 7740
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 136,
                  "lb": 301
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 562.5,
                  "lb": 1245
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 44,
                  "lb": 97
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 187.5,
                          "lb": 415
                      },
                      "oneRepMax": {
                          "kg": 44,
                          "lb": 97
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-12",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-13",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-14",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2625,
                  "lb": 5775
              },
              "maxWeight": {
                  "kg": 105,
                  "lb": 231,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 269
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-15",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-16",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1300,
                  "lb": 2860
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 74,
                  "lb": 162
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 260,
                          "lb": 572
                      },
                      "oneRepMax": {
                          "kg": 74,
                          "lb": 162
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-17",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5850,
                  "lb": 12900
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 136,
                  "lb": 301
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-19",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1980,
                  "lb": 4356
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 450,
                  "lb": 990
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-20",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2537.5,
                  "lb": 5600
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 797.5,
                          "lb": 1760
                      },
                      "oneRepMax": {
                          "kg": 99,
                          "lb": 219
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2240,
                  "lb": 4928
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 11
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 210
              },
              "sets": [
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 770,
                          "lb": 1694
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 210
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 770,
                          "lb": 1694
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 210
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 700,
                          "lb": 1540
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-21",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2380,
                  "lb": 5236
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 113,
                  "lb": 249
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 765,
                          "lb": 1683
                      },
                      "oneRepMax": {
                          "kg": 110,
                          "lb": 243
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 765,
                          "lb": 1683
                      },
                      "oneRepMax": {
                          "kg": 110,
                          "lb": 243
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 850,
                          "lb": 1870
                      },
                      "oneRepMax": {
                          "kg": 113,
                          "lb": 249
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 630,
                  "lb": 1404
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 24,
                  "lb": 55
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-22",
      "workout": "Biceps - Light",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 2520,
                  "lb": 5544
              },
              "maxWeight": {
                  "kg": 35,
                  "lb": 77,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 49,
                  "lb": 108
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 35,
                          "lb": 77
                      },
                      "setVolume": {
                          "kg": 420,
                          "lb": 924
                      },
                      "oneRepMax": {
                          "kg": 49,
                          "lb": 108
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Incline Dumbbell Curl": {
              "volume": {
                  "kg": 300,
                  "lb": 660
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 29
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 100,
                          "lb": 220
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 29
                      }
                  }
              ]
          },
          "Concentration Curls": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-23",
      "workout": "Shoulders - Light",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1710,
                  "lb": 3780
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 66,
                  "lb": 147
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 570,
                          "lb": 1260
                      },
                      "oneRepMax": {
                          "kg": 66,
                          "lb": 147
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1330,
                  "lb": 2940
              },
              "maxWeight": {
                  "kg": 47.5,
                  "lb": 105,
                  "reps": 9
              },
              "max1RM": {
                  "kg": 63,
                  "lb": 140
              },
              "sets": [
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 427.5,
                          "lb": 945
                      },
                      "oneRepMax": {
                          "kg": 62,
                          "lb": 136
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 47.5,
                          "lb": 105
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1050
                      },
                      "oneRepMax": {
                          "kg": 63,
                          "lb": 140
                      }
                  }
              ]
          },
          "Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 2790,
                  "lb": 6156
              },
              "maxWeight": {
                  "kg": 77.5,
                  "lb": 171,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 239
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 77.5,
                          "lb": 171
                      },
                      "setVolume": {
                          "kg": 930,
                          "lb": 2052
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 239
                      }
                  }
              ]
          },
          "Front Raises": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-24",
      "workout": "Legs - Light",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 1950,
                  "lb": 4290
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 191
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 650,
                          "lb": 1430
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 191
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 3510,
                  "lb": 7740
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 136,
                  "lb": 301
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  }
              ]
          },
          "Lunge": {
              "volume": {
                  "kg": 675,
                  "lb": 1494
              },
              "maxWeight": {
                  "kg": 37.5,
                  "lb": 83,
                  "reps": 6
              },
              "max1RM": {
                  "kg": 45,
                  "lb": 100
              },
              "sets": [
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 498
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 100
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 498
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 100
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 37.5,
                          "lb": 83
                      },
                      "setVolume": {
                          "kg": 225,
                          "lb": 498
                      },
                      "oneRepMax": {
                          "kg": 45,
                          "lb": 100
                      }
                  }
              ]
          },
          "Squat Jumps": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-26",
      "workout": "Chest - Heavy",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2375,
                  "lb": 5225
              },
              "maxWeight": {
                  "kg": 95,
                  "lb": 209,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 111,
                  "lb": 244
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 95,
                          "lb": 209
                      },
                      "setVolume": {
                          "kg": 475,
                          "lb": 1045
                      },
                      "oneRepMax": {
                          "kg": 111,
                          "lb": 244
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1875,
                  "lb": 4125
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 87,
                  "lb": 192
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 375,
                          "lb": 825
                      },
                      "oneRepMax": {
                          "kg": 87,
                          "lb": 192
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-27",
      "workout": "Triceps - Heavy",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2062.5,
                  "lb": 4550
              },
              "maxWeight": {
                  "kg": 82.5,
                  "lb": 182,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 212
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 82.5,
                          "lb": 182
                      },
                      "setVolume": {
                          "kg": 412.5,
                          "lb": 910
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 212
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2000,
                  "lb": 4400
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 93,
                  "lb": 205
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 400,
                          "lb": 880
                      },
                      "oneRepMax": {
                          "kg": 93,
                          "lb": 205
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1200,
                  "lb": 2640
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-28",
      "workout": "Back - Heavy",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Deadlift": {
              "volume": {
                  "kg": 2625,
                  "lb": 5775
              },
              "maxWeight": {
                  "kg": 105,
                  "lb": 231,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 122,
                  "lb": 269
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 105,
                          "lb": 231
                      },
                      "setVolume": {
                          "kg": 525,
                          "lb": 1155
                      },
                      "oneRepMax": {
                          "kg": 122,
                          "lb": 269
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-29",
      "workout": "Biceps - Heavy",
      "exercises": {
          "Barbell Curl": {
              "volume": {
                  "kg": 1000,
                  "lb": 2200
              },
              "maxWeight": {
                  "kg": 40,
                  "lb": 88,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 47,
                  "lb": 103
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 40,
                          "lb": 88
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 47,
                          "lb": 103
                      }
                  }
              ]
          },
          "Hammer Curls": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chin Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-04-30",
      "workout": "Shoulders - Heavy",
      "exercises": {
          "Shoulder Press": {
              "volume": {
                  "kg": 1625,
                  "lb": 3575
              },
              "maxWeight": {
                  "kg": 65,
                  "lb": 143,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 76,
                  "lb": 167
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 65,
                          "lb": 143
                      },
                      "setVolume": {
                          "kg": 325,
                          "lb": 715
                      },
                      "oneRepMax": {
                          "kg": 76,
                          "lb": 167
                      }
                  }
              ]
          },
          "Shoulder Plate Press Out": {
              "volume": {
                  "kg": 900,
                  "lb": 1980
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Upright Row": {
              "volume": {
                  "kg": 1562.5,
                  "lb": 3450
              },
              "maxWeight": {
                  "kg": 62.5,
                  "lb": 138,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 73,
                  "lb": 161
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 62.5,
                          "lb": 138
                      },
                      "setVolume": {
                          "kg": 312.5,
                          "lb": 690
                      },
                      "oneRepMax": {
                          "kg": 73,
                          "lb": 161
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-01",
      "workout": "Legs - Heavy",
      "exercises": {
          "Squat": {
              "volume": {
                  "kg": 2312.5,
                  "lb": 5100
              },
              "maxWeight": {
                  "kg": 92.5,
                  "lb": 204,
                  "reps": 5
              },
              "max1RM": {
                  "kg": 108,
                  "lb": 238
              },
              "sets": [
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  },
                  {
                      "reps": 5,
                      "weight": {
                          "kg": 92.5,
                          "lb": 204
                      },
                      "setVolume": {
                          "kg": 462.5,
                          "lb": 1020
                      },
                      "oneRepMax": {
                          "kg": 108,
                          "lb": 238
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 5850,
                  "lb": 12900
              },
              "maxWeight": {
                  "kg": 97.5,
                  "lb": 215,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 136,
                  "lb": 301
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 97.5,
                          "lb": 215
                      },
                      "setVolume": {
                          "kg": 1170,
                          "lb": 2580
                      },
                      "oneRepMax": {
                          "kg": 136,
                          "lb": 301
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-03",
      "workout": "Push A",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 95,
                  "lb": 209
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 95,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 95,
                          "lb": 209
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 95,
                          "lb": 209
                      }
                  }
              ]
          },
          "Seated Dumbbell Press": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 720,
                  "lb": 1584
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Lean Away Lateral Raise": {
              "volume": {
                  "kg": 240,
                  "lb": 528
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 13,
                  "lb": 28
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 80,
                          "lb": 176
                      },
                      "oneRepMax": {
                          "kg": 13,
                          "lb": 28
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-05",
      "workout": "Pull A",
      "exercises": {
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 4
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 4,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Close Grip Barbell Curl": {
              "volume": {
                  "kg": 560,
                  "lb": 1232
              },
              "maxWeight": {
                  "kg": 25,
                  "lb": 55,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 32,
                  "lb": 70
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 160,
                          "lb": 352
                      },
                      "oneRepMax": {
                          "kg": 25,
                          "lb": 56
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 32,
                          "lb": 70
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 25,
                          "lb": 55
                      },
                      "setVolume": {
                          "kg": 200,
                          "lb": 440
                      },
                      "oneRepMax": {
                          "kg": 32,
                          "lb": 70
                      }
                  }
              ]
          },
          "Shoulder Shrug": {
              "volume": {
                  "kg": 1920,
                  "lb": 4224
              },
              "maxWeight": {
                  "kg": 80,
                  "lb": 176,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 223
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 640,
                          "lb": 1408
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 223
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 640,
                          "lb": 1408
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 223
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 80,
                          "lb": 176
                      },
                      "setVolume": {
                          "kg": 640,
                          "lb": 1408
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 223
                      }
                  }
              ]
          },
          "Good Mornings": {
              "volume": {
                  "kg": 640,
                  "lb": 1408
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 84
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 160,
                          "lb": 352
                      },
                      "oneRepMax": {
                          "kg": 25,
                          "lb": 56
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-06",
      "workout": "Abs A",
      "exercises": {
          "Hanging Leg Raises": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Dumbbell Deadbugs": {
              "volume": {
                  "kg": 60,
                  "lb": 144
              },
              "maxWeight": {
                  "kg": 2.5,
                  "lb": 6,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 3,
                  "lb": 8
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 2.5,
                          "lb": 6
                      },
                      "setVolume": {
                          "kg": 20,
                          "lb": 48
                      },
                      "oneRepMax": {
                          "kg": 3,
                          "lb": 8
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 2.5,
                          "lb": 6
                      },
                      "setVolume": {
                          "kg": 20,
                          "lb": 48
                      },
                      "oneRepMax": {
                          "kg": 3,
                          "lb": 8
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 2.5,
                          "lb": 6
                      },
                      "setVolume": {
                          "kg": 20,
                          "lb": 48
                      },
                      "oneRepMax": {
                          "kg": 3,
                          "lb": 8
                      }
                  }
              ]
          },
          "Dumbbell Side Bend": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 10,
                  "lb": 22,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 14,
                  "lb": 31
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 10,
                          "lb": 22
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 14,
                          "lb": 31
                      }
                  }
              ]
          },
          "Plank": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 1
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 1,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 1,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 1,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-07",
      "workout": "Legs A",
      "exercises": {
          "Front Squat": {
              "volume": {
                  "kg": 1020,
                  "lb": 2256
              },
              "maxWeight": {
                  "kg": 42.5,
                  "lb": 94,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 54,
                  "lb": 119
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 340,
                          "lb": 752
                      },
                      "oneRepMax": {
                          "kg": 54,
                          "lb": 119
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 340,
                          "lb": 752
                      },
                      "oneRepMax": {
                          "kg": 54,
                          "lb": 119
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 42.5,
                          "lb": 94
                      },
                      "setVolume": {
                          "kg": 340,
                          "lb": 752
                      },
                      "oneRepMax": {
                          "kg": 54,
                          "lb": 119
                      }
                  }
              ]
          },
          "Dumbbell Sumo Deadlifts": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 19,
                  "lb": 42
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          },
          "Barbell Hip Thrusters": {
              "volume": {
                  "kg": 720,
                  "lb": 1584
              },
              "maxWeight": {
                  "kg": 30,
                  "lb": 66,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 38,
                  "lb": 84
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 30,
                          "lb": 66
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 38,
                          "lb": 84
                      }
                  }
              ]
          },
          "Standing Calf Raise": {
              "volume": {
                  "kg": 2400,
                  "lb": 5280
              },
              "maxWeight": {
                  "kg": 100,
                  "lb": 220,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 127,
                  "lb": 279
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 800,
                          "lb": 1760
                      },
                      "oneRepMax": {
                          "kg": 127,
                          "lb": 279
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 800,
                          "lb": 1760
                      },
                      "oneRepMax": {
                          "kg": 127,
                          "lb": 279
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 100,
                          "lb": 220
                      },
                      "setVolume": {
                          "kg": 800,
                          "lb": 1760
                      },
                      "oneRepMax": {
                          "kg": 127,
                          "lb": 279
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-17",
      "workout": "Chest - Light",
      "exercises": {
          "Bench Press": {
              "volume": {
                  "kg": 2700,
                  "lb": 5940
              },
              "maxWeight": {
                  "kg": 75,
                  "lb": 165,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 105,
                  "lb": 231
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 75,
                          "lb": 165
                      },
                      "setVolume": {
                          "kg": 900,
                          "lb": 1980
                      },
                      "oneRepMax": {
                          "kg": 105,
                          "lb": 231
                      }
                  }
              ]
          },
          "Push-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Barbell Press": {
              "volume": {
                  "kg": 1815,
                  "lb": 3993
              },
              "maxWeight": {
                  "kg": 55,
                  "lb": 121,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 77,
                  "lb": 169
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 660,
                          "lb": 1452
                      },
                      "oneRepMax": {
                          "kg": 77,
                          "lb": 169
                      }
                  },
                  {
                      "reps": 9,
                      "weight": {
                          "kg": 55,
                          "lb": 121
                      },
                      "setVolume": {
                          "kg": 495,
                          "lb": 1089
                      },
                      "oneRepMax": {
                          "kg": 71,
                          "lb": 157
                      }
                  }
              ]
          },
          "Dips": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Incline Dumbbell Press": {
              "volume": {
                  "kg": 540,
                  "lb": 1188
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 21,
                  "lb": 46
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 180,
                          "lb": 396
                      },
                      "oneRepMax": {
                          "kg": 21,
                          "lb": 46
                      }
                  }
              ]
          },
          "Chest Fly": {
              "volume": {
                  "kg": 360,
                  "lb": 792
              },
              "maxWeight": {
                  "kg": 15,
                  "lb": 33,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 20,
                  "lb": 44
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 150,
                          "lb": 330
                      },
                      "oneRepMax": {
                          "kg": 20,
                          "lb": 44
                      }
                  },
                  {
                      "reps": 6,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 90,
                          "lb": 198
                      },
                      "oneRepMax": {
                          "kg": 18,
                          "lb": 40
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 15,
                          "lb": 33
                      },
                      "setVolume": {
                          "kg": 120,
                          "lb": 264
                      },
                      "oneRepMax": {
                          "kg": 19,
                          "lb": 42
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-18",
      "workout": "Triceps - Light",
      "exercises": {
          "Close Grip Bench Press": {
              "volume": {
                  "kg": 2610,
                  "lb": 5760
              },
              "maxWeight": {
                  "kg": 72.5,
                  "lb": 160,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 101,
                  "lb": 224
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 72.5,
                          "lb": 160
                      },
                      "setVolume": {
                          "kg": 870,
                          "lb": 1920
                      },
                      "oneRepMax": {
                          "kg": 101,
                          "lb": 224
                      }
                  }
              ]
          },
          "Diamond Press Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Weight Plate Overhead Extensions": {
              "volume": {
                  "kg": 1440,
                  "lb": 3168
              },
              "maxWeight": {
                  "kg": 20,
                  "lb": 44,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 28,
                  "lb": 62
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 20,
                          "lb": 44
                      },
                      "setVolume": {
                          "kg": 240,
                          "lb": 528
                      },
                      "oneRepMax": {
                          "kg": 28,
                          "lb": 62
                      }
                  }
              ]
          },
          "Bench Dip": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Barbell Floor Press": {
              "volume": {
                  "kg": 2030,
                  "lb": 4466
              },
              "maxWeight": {
                  "kg": 70,
                  "lb": 154,
                  "reps": 11
              },
              "max1RM": {
                  "kg": 96,
                  "lb": 210
              },
              "sets": [
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 770,
                          "lb": 1694
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 210
                      }
                  },
                  {
                      "reps": 11,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 770,
                          "lb": 1694
                      },
                      "oneRepMax": {
                          "kg": 96,
                          "lb": 210
                      }
                  },
                  {
                      "reps": 7,
                      "weight": {
                          "kg": 70,
                          "lb": 154
                      },
                      "setVolume": {
                          "kg": 490,
                          "lb": 1078
                      },
                      "oneRepMax": {
                          "kg": 86,
                          "lb": 190
                      }
                  }
              ]
          }
      }
  },
  {
      "date": "2021-05-19",
      "workout": "Back - Light",
      "exercises": {
          "Deadlift": {
              "volume": {
                  "kg": 2550,
                  "lb": 5610
              },
              "maxWeight": {
                  "kg": 85,
                  "lb": 187,
                  "reps": 10
              },
              "max1RM": {
                  "kg": 113,
                  "lb": 249
              },
              "sets": [
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 850,
                          "lb": 1870
                      },
                      "oneRepMax": {
                          "kg": 113,
                          "lb": 249
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 850,
                          "lb": 1870
                      },
                      "oneRepMax": {
                          "kg": 113,
                          "lb": 249
                      }
                  },
                  {
                      "reps": 10,
                      "weight": {
                          "kg": 85,
                          "lb": 187
                      },
                      "setVolume": {
                          "kg": 850,
                          "lb": 1870
                      },
                      "oneRepMax": {
                          "kg": 113,
                          "lb": 249
                      }
                  }
              ]
          },
          "Pull-Up": {
              "volume": {
                  "kg": 0,
                  "lb": 0
              },
              "maxWeight": {
                  "kg": 0,
                  "lb": 0,
                  "reps": 8
              },
              "max1RM": {
                  "kg": 0,
                  "lb": 0
              },
              "sets": [
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  },
                  {
                      "reps": 8,
                      "weight": {
                          "kg": 0,
                          "lb": 0
                      },
                      "setVolume": {
                          "kg": 0,
                          "lb": 0
                      },
                      "oneRepMax": {
                          "kg": 0,
                          "lb": 0
                      }
                  }
              ]
          },
          "Bent-Over Row": {
              "volume": {
                  "kg": 1800,
                  "lb": 3960
              },
              "maxWeight": {
                  "kg": 50,
                  "lb": 110,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 70,
                  "lb": 154
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 50,
                          "lb": 110
                      },
                      "setVolume": {
                          "kg": 600,
                          "lb": 1320
                      },
                      "oneRepMax": {
                          "kg": 70,
                          "lb": 154
                      }
                  }
              ]
          },
          "Single Arm Dumbbell Row": {
              "volume": {
                  "kg": 630,
                  "lb": 1404
              },
              "maxWeight": {
                  "kg": 17.5,
                  "lb": 39,
                  "reps": 12
              },
              "max1RM": {
                  "kg": 24,
                  "lb": 55
              },
              "sets": [
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  },
                  {
                      "reps": 12,
                      "weight": {
                          "kg": 17.5,
                          "lb": 39
                      },
                      "setVolume": {
                          "kg": 210,
                          "lb": 468
                      },
                      "oneRepMax": {
                          "kg": 24,
                          "lb": 55
                      }
                  }
              ]
          }
      }
  }
]